class formHelper{
	constructor() {
		
	}
    init() {
    }
	resetForm(el) {
        let target = el.dataset.target;
        let form = document.getElementById(target);

		$(el).on('click', function (e) {
            app.form.clearForm(form);
            form.submit();
			e.preventDefault();
		});
	}
    clearForm(form){
        // clearing inputs
        // let form = document.getElementById(target);
        var inputs = form.getElementsByTagName('input');
        for (var i = 0; i<inputs.length; i++) {
            switch (inputs[i].type) {
                // case 'hidden':
                case 'text':
                    inputs[i].value = '';
                    break;
                case 'radio':
                case 'checkbox':
                    inputs[i].checked = false;   
            }
        }

        // clearing selects
        var selects = form.getElementsByTagName('select');
        for (var i = 0; i<selects.length; i++)
            selects[i].selectedIndex = 0;

        // clearing textarea
        var text= form.getElementsByTagName('textarea');
        for (var i = 0; i<text.length; i++)
            text[i].innerHTML= '';

        return false;
    }
}
window.app.add('form', new formHelper());